export function buildSummedDetailedInformation(tab) {
    const rrTab = tab.includes('proforma') ? 'proforma-rr-tab' : 'current-rr-tab';
    return {
        hasNamesColumn: false,
        headerRow: [],
        rows: {
            'first-row': {
                valueCells: [
                    { // % of Sq Ft - 0
                        unit: '%',
                        type: 'number',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const occupiedSqFt = tabs[rrTab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[rrTab].tables['sumed-general-information'].rows['first-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            const totalSqFt = precomputedValues.totalSpace;

                            let percent = 100.00;
                            if (totalSqFt !== 0) {
                                percent = parseFloat(occupiedSqFt / totalSqFt * 100);
                            }
                            return {internalValue: percent, displayValue: `(${percent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%)`};
                        },
                    },
                    {empty: true}, // Lease Type - 1
                    {empty: true}, // Reimb Code - 2
                    { // Annual Taxes - 3
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 3;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map(rowKey => parseFloat(rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 4
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 4;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualTaxes = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualTaxes / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual Insurance - 5
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 5;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map(rowKey => parseFloat(rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 6
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 6;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualInsurance = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualInsurance / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual CAM - 7
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 7;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map(rowKey => {
                                        const val = parseFloat(rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue);
                                        return !val || isNaN(val) ? 0 : val;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 8
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 8;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualInsurance = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualInsurance / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual Mgmt. Fee - 9
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 9;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map(rowKey => {
                                        const val = parseFloat(rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue);
                                        return !val || isNaN(val) ? 0 : val;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 10
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 10;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualMgmtFee = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualMgmtFee / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual Other - 11
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 11;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => {
                                        if (rows[rowKey].valueCells[colIndex].value) {
                                            return parseFloat(rows[rowKey].valueCells[colIndex].value)
                                        }
                                        return 0;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 12
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 12;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualOther = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualOther / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual Total - 13
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 13;
                            const rows = tabs[tab].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => {
                                        const cellValue = rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue;
                                        if (cellValue) {
                                            return parseFloat(cellValue)
                                        }
                                        return 0;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 14
                        editable: false,
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 14;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualTotal = tabs[tab].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualTotal / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {empty: true}, // Notes - 15
                    { // Empty - 16
                        empty: true,
                        hidden: tab === 'proforma-reimbursement-tab',
                    },
                    { // Annual RET - 17
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 17;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map(rowKey => parseFloat(rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 18
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 18;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualRet = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualRet / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual INS - 19
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 19;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map(rowKey => parseFloat(rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 20
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 20;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualIns = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualIns / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual CAM - 21
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 21;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map(rowKey => parseFloat(rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 22
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 22;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualCam = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualCam / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual Other - 23
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 23;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => {
                                        if (rows[rowKey].valueCells[colIndex].value) {
                                            return parseFloat(rows[rowKey].valueCells[colIndex].value)
                                        }
                                        return 0;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 24
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 24;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualOther = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualOther / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Annual Total - 25
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 25;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => {
                                        const cellValue = rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue;
                                        if (cellValue) {
                                            return parseFloat(cellValue)
                                        }
                                        return 0;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 26
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 26;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalAnnualTotal = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalAnnualTotal / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Empty - 27
                        empty: true,
                        hidden: tab === 'proforma-reimbursement-tab',
                    },
                    { // Monthly RET - 28
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 28;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => parseFloat(rows[rowKey].valueCells[colIndex].value))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 29
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 29;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalMonthlyRet = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalMonthlyRet / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Monthly INS - 30
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 30;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => parseFloat(rows[rowKey].valueCells[colIndex].value))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 31
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 31;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalMonthlyIns = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalMonthlyIns / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Monthly CAM - 32
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 32;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => parseFloat(rows[rowKey].valueCells[colIndex].value))
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    {// PSF - 33
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 33;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalMonthlyCam = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalMonthlyCam / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Monthly Other - 34
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 34;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => {
                                        if (rows[rowKey].valueCells[colIndex].value) {
                                            return parseFloat(rows[rowKey].valueCells[colIndex].value)
                                        }
                                        return 0;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 35
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 35;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalMonthlyOther = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalMonthlyOther / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // Monthly Total - 36
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 36;
                            const rows = tabs['current-reimbursement-tab'].tables['detailed-information'].rows;
                            let value = 0;
                            if (Object.keys(rows).length) {
                                value = Object.keys(rows)
                                    .map((rowKey) => {
                                        const cellValue = rows[rowKey].valueCells[colIndex].getComputedValue(tabs, rowKey, precomputedValues).internalValue;
                                        if (cellValue) {
                                            return parseFloat(cellValue)
                                        }
                                        return 0;
                                    })
                                    .reduce((a, b) => a + b);
                                value = parseFloat(value);
                            }
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                    { // PSF - 37
                        editable: false,
                        hidden: tab === 'proforma-reimbursement-tab',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const colIndex = 37;
                            const totalSqFt = precomputedValues.totalSpace;
                            const totalMonthlyTotal = tabs['current-reimbursement-tab'].tables['sumed-detailed-information'].rows[rowIdentifier].valueCells[colIndex - 1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                            const value = parseFloat(totalMonthlyTotal / totalSqFt);
                            const displayValue = !value || isNaN(value) || !isFinite(value)  ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                            return {internalValue: value, displayValue: displayValue};
                        }
                    },
                ]
            },
            'second-row': {
                valueCells: [
                    {
                        unit: '%',
                        type: 'number',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const vacantSqFt = tabs[rrTab].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[rrTab].tables['sumed-general-information'].rows['second-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            const totalSqFt = tabs[rrTab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[rrTab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;

                            let percent = 100.00;
                            if (totalSqFt !== 0) {
                                percent = parseFloat(vacantSqFt / totalSqFt * 100);
                            }

                            return {
                                internalValue: percent,
                                displayValue: `(${percent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%)`
                            };
                        },
                    },
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                ]
            },
            'third-row': {
                valueCells: [
                    {
                        unit: '%',
                        type: 'number',
                        editable: false,
                        styleClasses: 'borderless bold bg-krem',
                        getComputedValue(tabs, rowIdentifier, precomputedValues) {
                            const vacantSqFtPerc = tabs[rrTab].tables['sumed-detailed-information'].rows['second-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[rrTab].tables['sumed-detailed-information'].rows['second-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            const occupiedSqFtPerc = tabs[rrTab].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[rrTab].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                            const sumPerc = Math.min(parseFloat(parseFloat(vacantSqFtPerc) + parseFloat(occupiedSqFtPerc)), 100.0);
                            return {
                                internalValue: sumPerc,
                                displayValue: `(${sumPerc.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%)`
                            };
                        },
                    },
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                ]
            },
            'fourth-row': {
                valueCells: [
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true}, {empty: true}, {empty: true}, {empty: true}, {empty: true},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                    {empty: true, hidden: tab === 'proforma-reimbursement-tab'},
                ]
            }
        },
    }
}
